import styled from '@emotion/styled';

export const LogoImage = styled('img')(() => ({
  maxWidth: 200,
  maxHeight: 50,
  width: '100%',
  height: 'auto',
}));
